"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.checkDevice = checkDevice;
var _constants = require("@studio/constants");
var _logger = require("@studio/logger");
var LOG = new _logger.StudioLogger('checkDevice');
function checkDevice() {
  var isMobile = false;
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  // List mobile user agents
  var mobileDevicesRegexes = [/android/i, /webos/i, /iphone/i, /ipad/i, /ipod/i, /blackberry/i, /windows phone/i];
  var message = '';
  for (var _i = 0, _mobileDevicesRegexes = mobileDevicesRegexes; _i < _mobileDevicesRegexes.length; _i++) {
    var mobileDeviceRegex = _mobileDevicesRegexes[_i];
    if (userAgent.match(mobileDeviceRegex)) {
      isMobile = true;
    }
  }
  if (isMobile) {
    message = 'Unsupported device';
    LOG.warn("ReadinessCheck - ".concat(message, ":"), userAgent);
  }
  return {
    status: isMobile ? _constants.FAILED : _constants.PASSED,
    data: message
  };
}